import { Field, Form, Formik } from "formik";
import React from "react";
import styles from "./AdminMessageCreateForm.module.css";
import * as Yup from "yup";
import cx from "classnames";
import { useState } from "react";
import EmailPreview from "../Preview/EmailPreview";
import SMSPreview from "../Preview/SMSPreview";
import PushPreview from "../Preview/PushPreview";
const AdminMessageCreateFormSchema = Yup.object().shape({
  Title: Yup.string().required("Required"),
  Content: Yup.string().required("Required"),
});

export const AdminMessageCreateForm = ({ recipients, onSend }) => {
  const [content, setContent] = useState("");
  const [subject, setSubject] = useState("");

  return (
    <Formik
      initialValues={{
        Recipients: recipients,
        Title: "",
        Content: "",
        SMS: false,
        Email: true,
        Push: false,
      }}
      validationSchema={AdminMessageCreateFormSchema}
      onSubmit={onSend}
    >
      {({ errors, touched, values, setFieldValue }) => (
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <Form className={styles.form}>
              <div>
                <label htmlFor="Recipients">Recipients</label>
                <input disabled value={recipients} className="form-control" name="Recipients" />
              </div>

              <div>
                <label className={cx({ [styles["form_error-text"]]: errors.Title && touched.Title })} htmlFor="Title">
                  Subject
                </label>
                <Field maxLength={100} onKeyUp={(e) => setSubject(e.target.value)} className={cx("form-control", { [styles["form_input-text_error"]]: errors.Title && touched.Title })} name="Title" />
              </div>

              <div>
                <label className={cx({ [styles["form_error-text"]]: errors.Content && touched.Content })} htmlFor="Content">
                  Content
                </label>
                <Field onKeyUp={(e) => setContent(e.target.value)} rows={5} maxLength={200} className={cx(styles["form_input-textarea"], { [styles["form_input-textarea_error"]]: errors.Content && touched.Content })} name="Content" as="textarea" />
              </div>

              <div className={styles["form_channelsRow"]}>
                <div>
                  <Field type="checkbox" name="SMS" onChange={() => setFieldValue("SMS", !values.SMS)} />
                  <label htmlFor="SMS">SMS</label>
                </div>
                <div>
                  <Field type="checkbox" name="Email" onChange={() => setFieldValue("Email", !values.Email)}/>
                  <label htmlFor="Email">Email</label>
                </div>
                <div>
                  <Field type="checkbox" name="Push" onChange={() => setFieldValue("Push", !values.Push)} />
                  <label htmlFor="Push">Push</label>
                </div>
              </div>

              <div className={styles["form_submitButtonContainer"]}>
                <button type="submit" className="btn btn-rounded btn-primary">
                  Send
                </button>
              </div>
            </Form>
          </div>
          <div className="col-md-3 col-sm-6 col-6 text-center">
            <div className="container-preview">
              {values.Push && <PushPreview subject={subject} content={content}/>}
              {values.SMS && <SMSPreview content={content}/>}
              {values.Push && <img src="/assets/images/mobileEmpty.png" alt="" /> || values.SMS && <img src="/assets/images/mobileEmpty.png"  alt="" />}
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-6 text-center">
            {values.Email && <EmailPreview recipients={recipients} subject={subject} content={content}/>}
          </div>
        </div>
      )}
    </Formik>
  );
};
